import { type ImageOptions } from '@/lib/images'
import { MediaImg } from './MediaImg'

interface MediaStageProps {
  mediaId?: string | null
  imageUrl?: string | null
  thumbnailUrl?: string | null
  cdn?: ImageOptions
  alt?: string
}

/**
 * A whole image shown inside a fixed frame (lightbox, viewer). Instead of black or gray bars when the
 * picture's ratio differs from the frame, its own thumbnail fills the frame behind it, blurred and
 * slightly darkened. Fills its positioned parent: give the parent `relative` and a size.
 */
export const MediaStage = ({ mediaId, imageUrl, thumbnailUrl, cdn, alt = '' }: MediaStageProps) => (
  <div className="absolute inset-0 overflow-hidden" data-media-stage="">
    <MediaImg
      mediaId={mediaId}
      imageUrl={imageUrl}
      thumbnailUrl={thumbnailUrl}
      variant="thumb"
      cdn={{ w: 160, fit: 'max' }}
      alt=""
      aria-hidden
      className="absolute inset-0 h-full w-full scale-[1.2] object-cover blur-[40px]"
    />
    <div className="absolute inset-0 bg-black/30" aria-hidden />
    <MediaImg
      mediaId={mediaId}
      imageUrl={imageUrl}
      thumbnailUrl={thumbnailUrl}
      cdn={cdn}
      alt={alt}
      className="absolute inset-0 h-full w-full object-contain"
    />
  </div>
)
